import {BaseService} from './baseService.js';
import {Service} from './service.js';

/**
 * Handles Message Templates
 */
export class MessageTemplateService extends BaseService {
	
	static get properties() {		
		return {			
		};
	}
	
	constructor() {	
		super();
	}
	
	async getAllTemplates() {
		var data = await this.makeGETRequest('/api/resource/message-templates');
		return data;
	}	
	
	async saveTemplate(messageTemplate, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/message-templates/' + messageTemplate.templateId, messageTemplate);
		} else {
			saved = await this.makePOSTRequest('/api/resource/message-templates', messageTemplate);
		}
		return saved;
	}
	
	async activateTemplate(templateId) {	
		var result = await this.makePUTRequest('/api/resource/message-templates/' + templateId + '/activate');
		return result;
	}	

	async inactivateTemplate(templateId) {	
		var result = await this.makePUTRequest('/api/resource/message-templates/' + templateId + '/inactivate');
		return result;
	}
	
	async deleteTemplate(templateId) {
		var results = await this.makeDELETERequest('/api/resource/message-templates/' + templateId);
		return results;
	}

}
